import { ScrollToTopButtonProps } from '@/@studio-ai/props';
import { Button, cn } from '@heroui/react';
import { Icon } from '@iconify/react';
import { AnimatePresence, motion } from 'framer-motion';

export function ScrollToTopButton({ show, className, onPress }: ScrollToTopButtonProps) {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    className={cn('absolute left-1/2 top-2 z-10 -translate-x-1/2', className)}
                >
                    <Button
                        isIconOnly
                        size="sm"
                        radius="full"
                        variant="bordered"
                        className="h-8 w-8 border-default-300 bg-content1 shadow-lg hover:bg-default-100 dark:border-default-200"
                        aria-label="Scroll to top"
                        onPress={onPress}
                    >
                        <Icon
                            icon="lucide:chevron-up"
                            width={16}
                            height={16}
                            className="text-default-600"
                        />
                    </Button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
